














































import settings from '@/settings'
import n from '@/utils/notifications'
import t from '@/utils/tools'
import q from '@/graphql/query'

export default {
    name: 'interviews_table'

    props:
        component:
            type: String
            required: true
        reload:
            type: Boolean
            required: false

    watch:
        reload: (new_reload, old_reload)->
            if new_reload != old_reload
                @get_interviews()

    data: ()->
        alert: false
        loading: true
        search: ''
        pager_count: 5
        current_page: 1
        page_size: 10
        interviews: []

    computed:
        data_filtered: ()->
            self = @
            data = @interviews.filter (x) ->
                !self.search || x.user_str.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,"").includes(self.search.toLowerCase()) || x.user_str.toLowerCase().includes(self.search.toLowerCase())\
                || x.asked_user_str.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,"").includes(self.search.toLowerCase()) || x.asked_user_str.toLowerCase().includes(self.search.toLowerCase())\
                || x.interview_type.label.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,"").includes(self.search.toLowerCase()) || x.interview_type.label.toLowerCase().includes(self.search.toLowerCase())\
                || x.datetime_str.includes(self.search.toLowerCase()) \
                || x.reason.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,"").includes(self.search.toLowerCase()) || x.reason.toLowerCase().includes(self.search.toLowerCase())\
                || x.state.label.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,"").includes(self.search.toLowerCase()) || x.state.label.toLowerCase().includes(self.search.toLowerCase())
            return data

        data_paged: ()->
            data = @data_filtered.slice(((@current_page - 1) * @page_size), (@page_size * @current_page))
            return data

        first_user_label: ()->
            if @component == 'company'
                return 'De'
            return 'Par'

        second_user_label: ()->
            if @component == 'company'
                return 'Avec'
            return 'À'

        has_mutation_right: ()->
            return @has_access_right('interviews_self_edit')

        has_deletion_right: ()->
            return @has_access_right('interviews_self_delete')

        has_validation_right: ()->
            return @has_access_right('interviews_validate')

    methods:
        has_access_right: t.has_access_right

        check_date: (datetime)->
            return new Date(datetime) <= Date.now()

        file_icon_style: (has_file)->
            if has_file
                return 'color: inherit !important;'
            return 'color: red !important;'

        listen_sort: ({ column, prop, order })->
            # console.log "LISTEN", column, prop, order
            self = @
            @interviews.sort (a,b)->
                modifier = 1
                field_a = a[prop]
                field_b = b[prop]
                if prop == 'interview_type.label'
                    props = prop.split('.')
                    field_a = a[props[0]][props[1]]
                    field_b = b[props[0]][props[1]]
                else if prop == 'state'
                    field_a = a[prop]['slug']
                    field_b = b[prop]['slug']
                else if prop == 'datetime_str'
                    field_a = a['datetime']
                    field_b = b['datetime']
                if order == 'descending'
                    modifier = -1
                return field_a.toLowerCase().localeCompare(field_b.toLowerCase())*modifier
            # console.log "INTERVIEWS SORT ", @interviews

        handle_size_change: (val)->
            @page_size = val

        handle_current_change: (val)->
            @current_page = val

        open_file_modal: (interview)->
            # console.log "OPEN FILE MODAL ", interview
            # for f in interview.files
            #     console.log 'file name : ', f.filename
            @$emit('open-file-modal', interview)
            return

        revive_interview: (interview)->
            # console.log 'REVIVE ', interview
            self = @
            @$confirm("Êtes-vous sûr·e de vouloir envoyer à nouveau un email ?", 'Confirmation', {
                confirmButtonText: 'Oui',
                cancelButtonText: 'Annuler'
                })
                .then ()->
                    # console.log "INTERVIEW REVIVE", interview.uid
                    self.$http.post(settings.revive_interview, {"interview_uid":interview.uid})
                    .then (resp)->
                        if resp.body.status == "ok"
                            n.success()
                        else
                            n.error("interviews_table: revive_interview: then", resp.body.message)
                .catch (cancel)->
                    return

        edit_interview: (interview)->
            # console.log 'EDIT I ', interview
            @$emit('edit-interview', interview)
            return

        delete_interview: (interview_uid)->
            @$emit('delete-interview', interview_uid)
            return

        accept_interview: (interview, new_state)->
            interview.user_in_charge_uid = @$store.state.user_datas.app_user.uid
            for state in @$store.state.state_choice_set
                if state.slug == new_state
                    interview.state = t.deep_copy(state)
                    @$emit('accept-interview', interview)
                    return

        refuse_interview: (interview, new_state)->
            interview.user_in_charge_uid = @$store.state.user_datas.app_user.uid
            for state in @$store.state.state_choice_set
                if state.slug == new_state
                    interview.state = t.deep_copy(state)
                    @$emit('refuse-interview', interview)
                    return

        get_interviews: ()->
            self = @
            @loading = true
            q.run('get_interview_set', [@$store.getters.current_company.uid, @component])
            .then (resp)->
                if resp.body.errors? and resp.body.errors.length > 0
                    for e in resp.body.errors
                        n.gql_error(self.component+"_interviews: get_interviews: then", e.message)
                else
                    # console.log "GET interviews : ", resp.body.data.interview_set
                    self.interviews = resp.body.data.interview_set
                    self.loading = false
                    if self.interviews.length == 0
                        self.alert = true
                    else
                        self.alert = false
            .catch (resp)->
                n.catch_error(resp, "interviews_table: get_interviews()")

    beforeMount: ()->
        @get_interviews()
}
